/* import __COLOCATED_TEMPLATE__ from './search-form.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLEAR_BUTTON_CLASS_NAME = 'people-center-my-network-search-form__buttons__clear';

class SearchForm extends Component {

  get clearButtonClasses() {
    return clsx(
      CLEAR_BUTTON_CLASS_NAME,
      this.args.isClearButtonDisabled && `${CLEAR_BUTTON_CLASS_NAME}--disabled`,
    );
  }
}

export default SearchForm;
